<div class="table">
    <p-table #documentTable [value]="service.price.priceRanges" class="primeTable"
         autoLayout="true"  styleClass="easy-table" [lazy]="true">
        <ng-template pTemplate="caption">
            <div></div>
            <span style="font-weight: bold">{{ 'TOTAL-REGISTERS' | translate }}:
                {{service.price.priceRanges.length}}</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Min</th>
                <th>Max</th>
                <th>Valor</th>
                <th>Novo preço com reajuste</th>
                <th>Porcentagem de reajuste</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-price>
            <tr>
                <td >{{ price.startLengthRange }}</td>
                <td >{{ price.endLengthRange }}</td>
                <td >{{ price.value | dynamicCurrency: currentCurrency}}</td>
                <td >
                    <input name="readjustmentValue" type="number" pInputText
                        *ngIf="enableReadjustment" [(ngModel)]="price.readjustmentValue" (input)="onChange()"
                        >
                </td>
                <td ><span *ngIf="price.readjustmentValue">{{calcPorcentage(price) | percent:'.2' }}</span></td>
            </tr>
        </ng-template>
    </p-table>
</div>
